/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSectorDto } from '../models/CreateSectorDto';
import type { MessageResponse } from '../models/MessageResponse';
import type { SectorDetailResponse } from '../models/SectorDetailResponse';
import type { SectorResponse } from '../models/SectorResponse';
import type { UpdateSectorDto } from '../models/UpdateSectorDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SectorsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a sector
     * Create a new sector under a society. Only the society owner or an admin can create sectors.
     * @returns SectorResponse Sector created successfully.
     * @throws ApiError
     */
    public sectorsControllerCreate({
        societyId,
        requestBody,
    }: {
        /**
         * Society unique identifier
         */
        societyId: string,
        requestBody: CreateSectorDto,
    }): CancelablePromise<SectorResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/societies/{societyId}/sectors',
            path: {
                'societyId': societyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. SOCIETY_OWNER or ADMIN role required.`,
                404: `Society not found.`,
            },
        });
    }
    /**
     * Find nearby sectors
     * Find sectors whose coverage area includes the given lat/lng point. Uses Haversine distance against each sector's rangeKm. Optionally filter by societyId and override max radius.
     * @returns SectorResponse Nearby sectors returned.
     * @throws ApiError
     */
    public sectorsControllerFindNearby({
        latitude,
        longitude,
        radius,
        societyId,
        societyType,
    }: {
        /**
         * Latitude to search around
         */
        latitude?: number,
        /**
         * Longitude to search around
         */
        longitude?: number,
        /**
         * Maximum distance in km (overrides sector rangeKm)
         */
        radius?: number,
        /**
         * Filter by society ID
         */
        societyId?: string,
        /**
         * Filter by society type
         */
        societyType?: 'SECURITY' | 'INSTALLER' | 'DISTRIBUTOR',
    }): CancelablePromise<Array<SectorResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/sectors/nearby',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'radius': radius,
                'societyId': societyId,
                'societyType': societyType,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * List all sectors
     * Returns a paginated list of sectors with optional filters by societyId, type, search (label, address, or society name), and city. Each sector includes society summary with city for map display.
     * @returns any List of sectors.
     * @throws ApiError
     */
    public sectorsControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        societyId,
        type,
        search,
        city,
        disabled,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by society ID
         */
        societyId?: string,
        /**
         * Filter by sector type
         */
        type?: string,
        /**
         * Search by sector label, address, or society name (case-insensitive)
         */
        search?: string,
        /**
         * Filter by city from society headquarters address
         */
        city?: string,
        /**
         * Filter by disabled status
         */
        disabled?: boolean,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/sectors',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'societyId': societyId,
                'type': type,
                'search': search,
                'city': city,
                'disabled': disabled,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get sector detail
     * Returns a sector with its parent society summary and agent count.
     * @returns SectorDetailResponse Sector found.
     * @throws ApiError
     */
    public sectorsControllerFindOne({
        id,
    }: {
        /**
         * Sector unique identifier
         */
        id: string,
    }): CancelablePromise<SectorDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/sectors/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Sector not found.`,
            },
        });
    }
    /**
     * Update sector
     * Update a sector. Only the society owner or an admin can update sectors.
     * @returns SectorResponse Sector updated successfully.
     * @throws ApiError
     */
    public sectorsControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Sector unique identifier
         */
        id: string,
        requestBody: UpdateSectorDto,
    }): CancelablePromise<SectorResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/sectors/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Sector not found.`,
            },
        });
    }
    /**
     * Delete sector
     * Delete a sector and all associated data (cascade). Only the society owner or an admin can delete.
     * @returns MessageResponse Sector deleted successfully.
     * @throws ApiError
     */
    public sectorsControllerRemove({
        id,
    }: {
        /**
         * Sector unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/sectors/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Sector not found.`,
            },
        });
    }
}
